<div class="view-container">

    <h1 id="gamenight-title">Game Night Vote</h1>

    <p id="gamenight-instructions">
        <strong>Decide what we play next game night!</strong> 
        Make sure to join the VRC group by following the instructions in the <a href="https://discord.gg/Zqh6kMYUn6" target="_blank" class="discord-link">#group-invites</a> channel in the discord server!
    </p>
    
    <!-- Screen reader status announcements -->
    <div aria-live="polite" aria-atomic="true" class="sr-only" id="selection-status" #selectionStatus></div>
    
    <div 
        style="display: flex; flex-wrap: wrap; gap: 10px;"
        role="listbox"
        aria-multiselectable="true"
        class="option-list"
        aria-labelledby="gamenight-title"
        aria-describedby="gamenight-instructions"
        tabindex="0"
        [attr.aria-activedescendant]="activeOptionId"
        (keydown)="onListKeydown($event)"
        (focus)="onListFocus()"
        (blur)="activeIndex = 0"
    >
        @for (option of dataShareService.gameNightData.value?.options ?? []; track $index; let i = $index) {
            <div 
                [id]="'option-' + i"
                class="option-card" 
                role="option"
                [attr.aria-selected]="option.selected"
                [attr.aria-label]="option.selected ? option.title + ', selected' : option.title + ', not selected'"
                [class.selected]="option.selected" 
                [class.active]="i === activeIndex"
                (click)="toggleOption(option, i)"
                tabindex="-1"
            >
                
                <img 
                    [class.selected]="option.selected"
                    class="option-image" 
                    [src]="option.image_url" 
                    alt="{{option.title}}" 
                />
                
                <div style="display: flex; gap: 10px; align-items: center; margin: 0.5rem 1rem;">
                    
                    <mat-icon>{{option.selected ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                    <div style="font-size: 1.2rem; margin: 10px; text-align: center; flex: 1;">
                        {{option.title}}
                    </div>
                </div>
            </div>
        }
        </div>
</div>

<div style="position: sticky; bottom: 20px; width: 100%; display: flex; justify-content: center;">
    <div style="display: inline-flex; flex-direction: column; gap: 4px;">
        <button 
            mat-fab 
            extended 
            aria-label="Submit your game night vote selections"
            [disabled]="isSubmitting || (!pow && !powError)"
            (click)="submitVote()"
        >
            <mat-icon aria-hidden="true">{{isSubmitting ? 'hourglass_empty' : 'how_to_vote'}}</mat-icon>
            {{isSubmitting ? 'Submitting...' : (pow ? 'Submit Vote' : (powError ? 'Retry' : 'Preparing...'))}}
        </button>
        @if (!pow && !powError) {
            <app-pow-progress />
        }
    </div>
</div>
